import { Form, Formik } from 'formik';
import { Modal } from 'app/shared/components/modals/Modal';
import { IDripFeeder, ISources } from '../../types';
import { dripFeederValidationSchema } from '../../constants';
import { DripFeederForm } from './DripFeederForm';

interface IConfigurationTableModalProps {
  handleSubmit: (data: IDripFeeder) => void;
  currentDripFeeder: IDripFeeder | null;
  handleClose: () => void;
  dripFeederModalPosition: number;
  fetchedSources: ISources[] | undefined;
  isEditMode: boolean;
}

export const DripFeederModal = ({
  handleSubmit,
  currentDripFeeder,
  dripFeederModalPosition,
  handleClose,
  fetchedSources,
  isEditMode,
}: IConfigurationTableModalProps) => {
  const initialDripFeederState: IDripFeeder = {
    id: currentDripFeeder?.id || '',
    rank: currentDripFeeder?.rank || 999,
    name: currentDripFeeder?.name || 'New Drip Feeder Set 1',
    sources: currentDripFeeder?.sources || null,
    roleId: currentDripFeeder?.roleId || '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    maxPulls: currentDripFeeder?.maxPulls || 0,
    minutesBetweenPulls: currentDripFeeder?.minutesBetweenPulls || 0,
    pullNewestFirst: currentDripFeeder?.pullNewestFirst || false,
    useSourceWithLowestCountFirst: currentDripFeeder?.useSourceWithLowestCountFirst || false,
    isFronterSet: currentDripFeeder?.isFronterSet || false,
  };

  return (
    <Modal
      open
      fullWidth
      hideBackdrop
      resetPosition={dripFeederModalPosition}
      title="Add / Edit Drip Feeder"
      maxWidth="lg"
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialDripFeederState as IDripFeeder}
        validationSchema={dripFeederValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <DripFeederForm
              handleClose={handleClose}
              fetchedSources={fetchedSources}
              isEditMode={isEditMode}
              {...props}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
